import {
  Checkbox,
  Box,
  FormControlLabel, FormControl,
  Grid, makeStyles, Paper, Typography,
  CardActions, Button, TextField, IconButton,
} from '@material-ui/core'
import React, { useState, useEffect } from 'react'
import { orange } from '@material-ui/core/colors'
import {
  withStyles,
} from '@material-ui/core/styles'
import { useSelector, useDispatch } from 'react-redux'
import { ArrowLeft } from 'react-feather'
import { useParams } from 'react-router-dom'
import moment from 'moment-jalaali'
import classNames from 'classnames'
// eslint-disable-next-line import/no-cycle
import TablesStep from './TablesStep'
import {
  eventUsers, postEvent, selectorEvent, selectorEventUsers,
} from '../../app/slices/eventSlice'
import DeleteIcon from '../../icons/DeleteIcon'

const OrangeCheckbox = withStyles({
  root: {
    color: orange[400],
    padding: '0',
    margin: '0',
    '&$checked': {
      color: orange[600],
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />)

const CssTextField = withStyles((theme) => ({
  root: {
    width: '90%',
    height: '10vw',
    margin: '0 auto!important',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      width: '70vw',
      height: '40vw',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: '2px dashed orange',
      borderRadius: '20px',
    },
    '& label.Mui-focused': {
      color: 'orange',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'orange',
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: 'orange',
      },
    },
  },
}))(TextField)

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: '3rem',
    overflow: 'hidden',
    padding: theme.spacing(3, 1, 0, 1),
  },
  banner: {
    display: 'flex',
    marginTop: '3rem',
    overflow: 'hidden',
    flexDirection: 'row',
    minHeight: '20vh',
    padding: '1rem',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  icons: {
    color: '#b2b6c0',
    transition: '0.2s',
    '&:hover': {
      color: '#f39994',
    },
  },
  acceptRoles: {
    wordBreak: 'break-all',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '3rem',
  },
  buttonNext: {
    width: theme.spacing(30),
    backgroundColor: 'orange',
    alignSelf: 'center',
    marginBottom: theme.spacing(10),
  },
  title: {
    padding: theme.spacing(2.5),
    fontWeight: 'bold',
    color: 'orange',
  },
  boxCheck: {
    display: 'flex',
    flexDirection: 'column',
    paddingInline: theme.spacing(2.5),
  },
  input: {
    display: 'none',
  },
  cardActions: {
    maxWidth: '25%',
    borderRadius: '1rem',
    border: '2px dashed orange',
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
    },
  },
  boxFiles: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    margin: '4rem auto',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  buttonFiles: {
    width: '100%',
    height: '100%',
    textAlign: 'center',
  },
  boxDetails: {
    display: 'flex',
    flexDirection: 'column',
    margin: '0 auto',
    justifyContent: 'center',
  },
  textField: {
    width: '98%',
  },
  textbox: {
    display: 'flex',
    padding: '0 1rem',
    flexDirection: 'column',
    justifyContent: 'center',
    flexGrow: '1',
  },
  titleBox: {
    marginBottom: '.5rem',
    color: 'orange',
  },
  drscriptionBox: {
    marginBottom: '.5rem',
  },

  bannerIamge: {
    minHeight: '20vh',
    width: '20%',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    borderRadius: '1rem',
    justifyContent: 'center',
    overflow: 'hidden',
    cursor: 'pointer',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      marginBottom: '2rem',
    },
    '& img': {
      width: '100%',
      height: '100%',
      display: 'block',
    },
  },

  btnBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  btnBanner: {
    padding: '1rem 3rem',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  redColor: { color: 'red' },

  legal: {
    overflow: 'hidden',
    textAlign: 'justify',
    whiteSpace: 'pre-line',
    wordWrap: ' break-word',
  },
  paddingInline: {
    paddingInline: theme.spacing(2.5),
  },
  textWidth: {
    width: '68vw',
  },
  textLegal: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '10px',
    paddingRight: theme.spacing(2.5),
  },
  checkBoxPadding: {
    paddingInline: theme.spacing(1.2),
  },
  label: {
    width: '100%',
  },
  filesShow: {
    display: 'flex',
    width: '90%',
    alignItems: 'center',
    margin: '0 auto',
    marginBottom: '1rem',
    justifyContent: 'space-between',
  },
}))

const columnLists = {
  title: '',
  subject: 'موضوع',
  category: 'رده سنی ',
  closingDate: 'مهلت ارسال اثر',
  expierDate: 'اختتامیه',
}

const RolesStep = ({ setActiveStep, steps }) => {
  //
  const classes = useStyles()
  const dispatch = useDispatch()
  const { userId } = useParams()
  const {
    event, conditions, awards, laws, acceptFile,
  } = useSelector((state) => selectorEvent(state))
  const userEvent = useSelector(selectorEventUsers)
  //
  const [description, setDescription] = useState('')
  const [selectedFile, setSelectedFile] = useState([])
  const [disabled, setDisabled] = useState([])
  //
  useEffect(() => {
    if (userId) {
      dispatch(eventUsers({
        EventId: 5,
        UserId: 1277,
      }))
    }
  }, [userId])

  const handleDescription = (e) => setDescription(e.target.value)
  const handleChecked = (e) => {
    if (disabled.filter((item) => item.id === e.id).length === 0) {
      setDisabled([...disabled, e])
    } else {
      const newState = disabled.filter((item) => item.id !== e.id)
      setDisabled(newState)
    }
  }

  const checkDisabled = () => {
    return disabled?.length === laws?.length && selectedFile.length > 0
  }
  console.log(acceptFile, 'acceptFile')
  const handleFiles = (e) => {
    const [files] = e.target.files
    const checkItem = selectedFile?.filter((file) => file?.type === files?.type)
    if (checkItem !== 0) {
      const index = selectedFile?.findIndex((file) => file?.type === files?.type)
      const newState = selectedFile
      newState[index] = files
      console.log(newState, 'newState')
      setSelectedFile([...newState])
    }

    if (files && !selectedFile?.includes(files)) {
      setSelectedFile([...selectedFile, files])
    }
  }

  const handleDeleteFile = (name) => {
    const newFile = selectedFile.filter((item) => item.name !== name)
    setSelectedFile(newFile)
  }

  const handleClick = (e) => {
    e.preventDefault()
    const formData = new FormData()
    const data = {
      EventId: event.id,
      Description: description,
    }
    formData.append('model', JSON.stringify(data))
    if (selectedFile) {
      selectedFile.map((file) => formData.append('attachments', file))
    }

    dispatch(postEvent(formData))
  }

  const handleBackNavigate = () => {
    setActiveStep(steps[TablesStep.name])
  }

  const data = {
    description: userEvent?.[0]?.description,
    conditions: userEvent?.[0]?.event?.conditions.split('\\n'),
    awards: userEvent?.[0]?.event?.awards.split('\\n'),
    laws: userEvent?.[0]?.event?.laws.split('\\n'),
    acceptFile: userEvent?.[0]?.event?.acceptFile,
    acceptFileTitle: userEvent?.[0]?.event?.acceptFileTitle,
  }

  return (
    <Grid item xs={12}>
      <Paper classes={{ root: classes.banner }}>
        <Box classes={{ root: classes.bannerIamge }}>
          {event?.banner?.url && (
          <img
            src={event?.banner?.url || userEvent?.[0]?.event?.banner?.url}
            alt={event?.banner?.mimeType || userEvent?.[0]?.event?.banner?.mimeType}
          />
          ) }
        </Box>
        <Box classes={{ root: classes.textbox }}>
          {
            Object.keys(columnLists).map((item, index) => {
              // eslint-disable-next-line no-lone-blocks
              {
                return index === 0
                  ? (
                    <Typography
                      key={item}
                      classes={{ root: classes.titleBox }}
                      variant="h3"
                    >
                      {event[item] ?? userEvent?.[0]?.event[item]}
                    </Typography>
                  )
                  : (
                    <Typography
                      key={item}
                      variant="body1"
                      classes={{ root: classes.drscriptionBox }}
                    >
                      {columnLists[item]}
                      { ' : ' }
                      {(item === 'category') ? (event[item]?.name || userEvent?.[0]?.event[item])
                        : (event[item] || (item === 'closingDate' || item === 'expierDate' ? moment(userEvent?.[0]?.event[item]).format('jYYYY/jMM/jDD')
                          : userEvent?.[0]?.event[item]))}
                    </Typography>
                  )
              }
            })
           }
        </Box>
        <Box classes={{ root: classes.btnBox }}>
          <Button
            classes={{ root: classNames(classes.btnBanner, classes.redColor) }}
            onClick={handleBackNavigate}
          >
            بازگشت
            <ArrowLeft />
          </Button>
        </Box>
      </Paper>
      <Paper classes={{ root: classes.root }}>
        <Typography classes={{ root: classes.title }} variant="subtitle1">شرایط شرکت در رویداد :</Typography>
        {
      (conditions || data?.conditions)?.map((item) => {
        return (
          <Box classes={{ root: classes.textLegal }}>
            <Typography
              classes={{ root: classNames(classes.legal, classes.paddingInline) }}
              variant="body1"
            >
              &#9899;
            </Typography>
            <Typography
              classes={{ root: classNames(classes.legal, classes.textWidth) }}
              variant="body1"
            >
              {item}
            </Typography>
          </Box>
        )
      })
}
        <Typography classes={{ root: classes.title }} variant="subtitle1">جوایز :</Typography>
        {
      (awards || data?.awards)?.map((item) => {
        return (
          <Box classes={{ root: classes.textLegal }}>
            <Typography
              classes={{ root: classNames(classes.legal, classes.paddingInline) }}
              variant="body1"
            >
              &#9899;
            </Typography>
            <Typography
              classes={{ root: classNames(classes.legal, classes.textWidth) }}
              variant="body1"
            >
              {item}
            </Typography>
          </Box>
        )
      })
}
        <Typography classes={{ root: classes.title }} variant="subtitle1">شرایط و قوانین :</Typography>
        <Box classes={{ root: classes.boxCheck }}>
          {
      (laws || data?.laws)?.map((law) => {
        return (
          <FormControl classes={{ root: classes.textLegal }}>
            <FormControlLabel
              classes={{ root: classes.acceptRoles }}
              control={(
                <OrangeCheckbox
                  color="primary"
                  name={law.item}
                  classes={{ root: classes.checkBoxPadding }}
                  onChange={() => handleChecked(law)}
                />
                )}
            />
            <Typography classes={{ root: classNames(classes.legal, classes.textWidth) }}>
              {law.item}
            </Typography>
          </FormControl>
        )
      })
}
        </Box>
        <form method="post" onSubmit={handleClick}>
          <Box gridGap="5vw" classes={{ root: classes.boxFiles }}>
            { acceptFile?.map((item) => {
              return (
                <CardActions classes={{ root: classes.cardActions }}>
                  <label htmlFor="contained-button-file" className={classes.label}>
                    <input
                      accept={acceptFile?.join('')}
                      className={classes.input}
                      id="contained-button-file"
                      multiple
                      type="file"
                      onChange={handleFiles}
                    />
                    <Button
                      component="span"
                      color="primary"
                      fullWidth
                      variant="text"
                      classes={{ root: classes.buttonFiles }}
                    >
                      لطفا فایل مورد نظر را در قالب
                      {' '}
                      {item.split('/')[1]}
                      {' '}
                      بارگزاری نمایید
                      <br />
                      <br />
                      نوع فرمت
                      {' '}
                      {item}
                    </Button>
                  </label>
                </CardActions>
              )
            })}
          </Box>
          {
              selectedFile.map((file) => {
                return (
                  <Box classes={{ root: classes.filesShow }}>
                    <Typography>{file?.name}</Typography>
                    <IconButton onClick={() => handleDeleteFile(file?.name)}>
                      <DeleteIcon className={classes.icons} />
                    </IconButton>
                  </Box>
                )
              })
            }
          <Box classes={{ root: classes.boxDetails }}>
            <Typography classes={{ root: classes.title }}>توضیحات تکمیلی </Typography>
            <CssTextField
              classes={{ root: classes.textField }}
              fullWidth
              type="text"
              size="small"
              variant="outlined"
              multiline
              rows={4}
              rowsMax={10}
              value={data?.description && data?.description}
              disabled={data?.awards}
              onChange={handleDescription}
            />
            <Button
              variant="contained"
              color="primary"
              type="submit"
              classes={{ root: classes.buttonNext }}
              size="large"
              disabled={!checkDisabled()}
            >
              تایید و ارسال
            </Button>
          </Box>
        </form>
      </Paper>
    </Grid>
  )
}
export default RolesStep
